import { formatForAPI } from '@eb/datetime';
import {
    event,
    constants as eventPublishUtilsConstant,
} from '@eb/event-create-publish-utils';
import { prepareResource } from '@eb/resource-cache';

import {
    getSchedulePrivacySettingsCacheKey,
    schedulePublishToPublicEvent,
    getEventScheduleToPublish,
    deleteEventSchedulePrivateToPublish,
} from '../../api';

import { STATE_RESOURCE_CACHE_NAME } from '../../constants';

const { PUBLIC_VALUE } = eventPublishUtilsConstant;

const {
    connectUtils: { dispatchPublishEvent },
    api: { schedulePublishErrorSpec },
    utils: { getErrorStringFromTranslatedError },
    actions: { schedulePrivacySettingsFailure },
} = event;

const prepareGetEventScheduleToPublish = (errorSpec, eventId, timezone) => (
    dispatch,
) =>
    prepareResource(
        dispatch,
        STATE_RESOURCE_CACHE_NAME,
        getSchedulePrivacySettingsCacheKey(eventId),
        () => getEventScheduleToPublish(errorSpec, eventId, timezone),
        () => false,
    );

export const createPrivateToPublicPublishTimer = (
    values,
    timeZone,
    eventId,
) => {
    const { schedulePublishDate, schedulePublishTime } = values;

    const schedulePublishBody = {
        event_privacy_schedule: {
            schedule_date: formatForAPI(
                schedulePublishDate,
                schedulePublishTime,
                timeZone,
            ),
            privacy_type: PUBLIC_VALUE,
        },
    };

    return schedulePublishToPublicEvent(
        schedulePublishBody,
        schedulePublishErrorSpec,
        eventId,
    );
};

export const updateSchedulePublishToPublicResource = (
    values,
    timeZone,
    eventId,
) => async (dispatch) => {
    try {
        dispatch(createPrivateToPublicPublishTimer(values, timeZone, eventId));
    } catch (error) {
        dispatch(
            schedulePrivacySettingsFailure(
                getErrorStringFromTranslatedError(
                    error,
                    schedulePublishErrorSpec.default(),
                ),
            ),
        );
        return null;
    }
};

export const createSchedulePublishToPublicResource = (
    values,
    timeZone,
    eventId,
    category,
    dimensions,
) => async (dispatch) => {
    try {
        await createPrivateToPublicPublishTimer(values, timeZone, eventId);
        dispatch(dispatchPublishEvent({ eventId, category, dimensions }));
    } catch (error) {
        dispatch(
            schedulePrivacySettingsFailure(
                getErrorStringFromTranslatedError(
                    error,
                    schedulePublishErrorSpec.default(),
                ),
            ),
        );
        return null;
    }
};

export const getEventSchedulePublishToPublicResource = (
    eventId,
    timezone,
) => async (dispatch) => {
    if (!eventId) {
        return;
    }

    try {
        return await dispatch(
            prepareGetEventScheduleToPublish(
                schedulePublishErrorSpec,
                eventId,
                timezone,
            ),
        );
    } catch (error) {
        dispatch(
            schedulePrivacySettingsFailure(
                getErrorStringFromTranslatedError(
                    error,
                    schedulePublishErrorSpec.default(),
                ),
            ),
        );
        return null;
    }
};

export const deleteSchedulePublishToPublicResource = (id) => (dispatch) => {
    if (!id) {
        return;
    }

    try {
        dispatch(
            deleteEventSchedulePrivateToPublish(schedulePublishErrorSpec, id),
        );
    } catch (error) {
        dispatch(
            schedulePrivacySettingsFailure(
                getErrorStringFromTranslatedError(
                    error,
                    schedulePublishErrorSpec.default(),
                ),
            ),
        );
        return null;
    }
};
